import { RichTextAnswerFragment } from 'approot/activity-builder/present/__generated__/RichTextAnswerFragment';
import { SuggestedAnswerFragment_suggestedAnswers_answer } from '../../suggested-answers/__generated__/SuggestedAnswerFragment';

export function getRichtextAnswer(
  answer:
    | {
        uuid: string;
        answer: SuggestedAnswerFragment_suggestedAnswers_answer | null;
      }
    | null
    | undefined
) {
  return (answer?.answer as RichTextAnswerFragment)?.richtext;
}
